module.exports = __webpack_public_path__ + "static/img/computer-sm.3c254c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/computer-sm.png
// module id = YMDr
// module chunks = 0